import styled from 'styled-components';

const InputContainer = ({ children, hasError }) => {
  return <Container hasError={hasError}>{children}</Container>;
};

export default InputContainer;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  input {
    font-family: ${props => props.theme.baseFont.fontFamily};
    font-weight: ${props => props.theme.input.fontWeight};
    font-size: ${props => props.theme.input.fontSize};
    color: ${props => props.theme.input.fontColor};
    background-color: ${props => props.theme.input.backgroundColor};
    border-bottom: ${props => props.theme.input.borderBottom};
    border-left: ${props => props.theme.input.borderLeft};
    border-right: ${props => props.theme.input.borderRight};
    border-top: ${props => props.theme.input.borderTop};
    border-radius: ${props => props.theme.input.borderRadius ?? '0'};
    padding: ${props => props.theme.input.padding ?? '0.563rem 0.875rem'};

    &:focus {
      background-color: ${props => props.theme.input.focus.backgroundColor};
      border-color: ${props => props.theme.input.focus.borderColor};
      border-width: ${props => props.theme.input.focus.borderWidth};
    }
  }

  label {
    color: ${props => props.theme.input.label.fontColor};
    font-size: ${props => props.theme.input.label.fontSize};
    font-weight: ${props => props.theme.input.label.fontWeight};
    margin: 0 0 0.4375rem 0.25rem;
    display: flex;
    justify-content: space-between;
  }
`;
